import { useRecipientPageContext } from '../RecipientPage/context/recipient-page-context';
import { RecipientPage } from '../RecipientPage/RecipientPage';
import { FullScreenPublicTemplate } from './FullScreenPublicTemplate';
import {
    usePublicTemplatePreview,
    UsePublicTemplatePreviewParams
} from './usePublicTemplatePreview';

export const PublicTemplatePreviewWrapper = ({
    clickUseTemplateSubscriber
}: UsePublicTemplatePreviewParams) => {
    const { templateData } = useRecipientPageContext();
    usePublicTemplatePreview({ clickUseTemplateSubscriber });

    return (
        <div className="template-preview">
            {templateData!.public_configuration.is_gallery_template ? (
                <FullScreenPublicTemplate />
            ) : (
                <RecipientPage />
            )}
        </div>
    );
};
